module.exports = __webpack_public_path__ + "static/media/document.61ef4996.svg";